import React, { useState } from 'react';
import ReportcenterFilter from 'App/pages/Reportcenter/ReportcenterContent/ReportcenterFilter/ReportcenterFilter';
import { Checkbox, DateInput, Flex, Input, Text } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';
import BemClass from '@upsales/components/Utils/bemClass';
import { ChangeType } from 'Resources/OrderChangeLog';
import moment from 'moment';
import AppService from 'App/legacy/AppService';

export const UserFilter = ({ filter, onChange }: { filter: number[]; onChange: (filter: any) => void }) => {
	const classes = new BemClass('OrderChangeLog');
	const { t } = useTranslation();

	const users = AppService.getUsers(undefined, true);

	const [search, setSearch] = useState('');
	return (
		<ReportcenterFilter
			icon="user"
			resetFilter={() => {
				onChange([]);
			}}
			className={classes.elem('userFilter').b()}
			renderSelected={() =>
				filter.length > 0
					? `${t(filter.length === 1 ? 'default.user' : 'default.users')}: ${filter.length} ${t(
							'default.selected'
					  ).toLowerCase()}`
					: `${t('default.user')}: ${t('reportcenter.filter.notActive')}`
			}
			placeholder={`${t('default.user')}: ${t('reportcenter.filter.notActive')}`}
			value={filter}
			updateFilterHeight={() => setSearch('')}
			values={{ User: { value: filter, comparison: 'eq' } }}
			renderCustomDropdown={() => (
				<Flex direction="column">
					<Flex space="plm prm mtm mbm">
						<Input
							placeholder={t('default.search')}
							onChange={e => {
								setSearch(e.target.value);
							}}
							onClear={() => setSearch('')}
						/>
					</Flex>
					{users.map(user => {
						if (!user.name) {
							return null;
						}

						if (search && !user.name.toLowerCase().includes(search.toLowerCase())) {
							return null;
						}

						const checked = filter.includes(user.id);

						return (
							<Flex
								className={classes.elem('userFilterItem').b()}
								key={user.id}
								alignItems="center"
								gap="u1"
								space="plm prm ptm pbm"
								onClick={() => {
									if (checked) {
										onChange(filter.filter(id => id !== user.id));
									} else {
										onChange([...filter, user.id]);
									}
								}}
							>
								<Checkbox checked={checked} />
								<Text>{user.name}</Text>
							</Flex>
						);
					})}
				</Flex>
			)}
		/>
	);
};

export const DateFilter = ({
	filter,
	onChange
}: {
	filter: { start?: any; end?: any };
	onChange: (filter: any) => void;
}) => {
	const classes = new BemClass('OrderChangeLog');
	const { t } = useTranslation();

	return (
		<>
			<DateInput
				closeOnSelect
				className={classes.elem('dateInput').b()}
				placeholder={t('default.from')}
				max={filter.end ?? new Date()}
				value={filter.start}
				onChange={e => {
					onChange({ ...filter, start: e.target.value });
				}}
				onClear={() => {
					onChange({ ...filter, start: undefined });
				}}
			/>
			<DateInput
				closeOnSelect
				className={classes.elem('dateInput').b()}
				placeholder={t('default.to')}
				min={filter.start}
				max={new Date()}
				value={filter.end}
				onChange={e => {
					onChange({ ...filter, end: moment(e.target.value).endOf('day').toDate() });
				}}
				onClear={() => {
					onChange({ ...filter, end: undefined });
				}}
			/>
		</>
	);
};

export const ChangeTypeFilter = ({ filter, onChange }: { filter: string[]; onChange: (filter: any) => void }) => {
	const classes = new BemClass('OrderChangeLog');
	const { t } = useTranslation();

	return (
		<ReportcenterFilter
			icon="th-list"
			resetFilter={() => {
				onChange([]);
			}}
			className={classes.elem('changeTypeFilter').b()}
			renderSelected={() =>
				filter.length > 0
					? `${t(filter.length === 1 ? 'auditLog.changeType' : 'auditLog.changeTypes')}: ${filter.length} ${t(
							'default.selected'
					  ).toLowerCase()}`
					: `${t('auditLog.changeType')}: ${t('reportcenter.filter.notActive')}`
			}
			placeholder={`${t('auditLog.changeType')}: ${t('reportcenter.filter.notActive')}`}
			value={filter}
			values={{}}
			renderCustomDropdown={() => (
				<Flex direction="column">
					{Object.values(ChangeType).map(type => {
						const checked = filter.includes(type);

						return (
							<Flex
								className={classes.elem('changeTypeFilterItem').b()}
								key={'filter' + type}
								space="plm prm ptm pbm"
								alignItems="center"
								gap="u1"
								onClick={() => {
									if (checked) {
										onChange(filter.filter(id => id !== type));
									} else {
										onChange([...filter, type]);
									}
								}}
							>
								<Checkbox checked={checked} />
								<Text>{t(`auditLog.type.${type}`)}</Text>
							</Flex>
						);
					})}
				</Flex>
			)}
		/>
	);
};
